module.exports = __webpack_public_path__ + "img/figure-25.41ffdc33.png";